// @flow
import JobDetail from 'components/job/jobDetail/JobDetail';
import { connect } from 'react-redux';
import { fetchJobDetail } from 'actions/jobActions';
import { postContactForm, fetchAllContactForm } from 'actions/formActions';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/job/jobDetail/JobDetail';

export default connect(
  (state: StateType): StateProps => ({
    title: 'Recrutement',
    description: 'Retrouvez les offres d’emploi de la Fédération Française de Rugby et de ses différents clubs.',
    details: state.jobDetailState.details,
    meta_title: 'Recrutement',
    meta_description: 'Retrouvez les offres d’emploi de la Fédération Française de Rugby et de ses différents clubs.',
    status: state.jobDetailState.status,
    contactFormList: state.formState.contactFormList,
    userPref: state.userState.userPref
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchJobDetail: (slug: string) => dispatch(fetchJobDetail(slug)),
    onSubmit: (formInputs: Object, id: number) => dispatch(postContactForm(formInputs, id)),
    fetchContactForm: () => dispatch(fetchAllContactForm()),
  })
)(JobDetail);
